import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  location: string;
  text: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  age,
  location,
  text,
  delay = 0
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-pink-100 relative" data-id="element-9">
      <Quote className="absolute top-4 right-4 w-8 h-8 text-pink-200" data-id="element-10" />
      <div className="mb-4" data-id="element-11">
        <div className="flex gap-1 mb-2" data-id="element-12">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20" data-id="element-13">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-14" />
            </svg>)}
        </div>
        <p className="text-gray-700 italic leading-relaxed" data-id="element-15">"{text}"</p>
      </div>
      <div className="border-t border-pink-100 pt-3" data-id="element-16">
        <p className="font-bold text-gray-900" data-id="element-17">
          {name}, {age}
        </p>
        <p className="text-sm text-gray-500" data-id="element-18">{location}</p>
      </div>
    </motion.div>;
}